
import SubPageHeading from "@/components/other/SubPageHeading/SubPageHeading.vue";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "StudentSubPageHeading",
  components: { SubPageHeading },
  props: {
    subLabel: { type: String, required: true },

    mainPageHeadingLinkPath: { type: String, required: true },
    onClickBack: { type: Function as PropType<() => void>, required: true },
  },
});
